import {gql} from "apollo-boost";

export const GET_STUDENTS = gql`
  query {
    getStudents{

      id
      code
      prefix{
        id nameLocal nameEng nameShortLocal nameShortEng
      }
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      gender
      telephone
      email
      birthDate
      citizenId
    }
  }
`;

export const GET_STUDENTS_BY_FILTER = gql`
  query getStudentsByFilter ($studentFilterInput: StudentFilterInput) {
    getStudentsByFilter(
      studentFilterInput: $studentFilterInput
    ) {
      id
      code
      prefix{
        id nameLocal nameEng nameShortLocal nameShortEng
      }
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      gender
      telephone
      email
      birthDate
      citizenId
    }
  }
`;

export const GET_STUDENTS_BY_CODE__OR_NAME = gql`
  query getStudentsByCodeOrName ($codeOrName: String!, $limit: Int) {
    getStudentsByCodeOrName(
      codeOrName: $codeOrName,
      limit: $limit,
    ) {
      id code firstNameLocal lastNameLocal firstNameEng lastNameEng
      email telephone picturePath
      curriculum { id nameLocal nameEng}
      studentStatus { id nameLocal nameEng}
      label
    }
  }
`;

export const GET_STUDENT = gql`
  query getStudent($id : ID!){
    getStudent (
      id: $id
    ) {
      id
      degree{id code nameLocal nameEng}
      curriculum{id code nameLocal nameEng}
      faculty{id code nameLocal nameEng}
      department{id code nameLocal nameEng}
      code
      prefix{
        id nameLocal nameEng nameShortLocal nameShortEng
      }
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      gender
      telephone
      email
      birthDate
      citizenId
      project{id nameLocal nameEng}
      studentStatus{id nameLocal nameEng}
      examLocation
      user{id userLogin }
    }
  }
`;

export const ADD_STUDENT = gql`
  mutation addStudent(
    $studentInput: StudentInput!,
    $curriculumId: ID!,
    $facultyId: ID!,
    $prefixId: ID!,
    $userId: ID,
  ) {
    addStudent(
      studentInput: $studentInput
      curriculumId: $curriculumId
      facultyId: $facultyId
      prefixId: $prefixId
      userId: $userId
    ) {
      id
      degree{id code nameLocal nameEng}
      curriculum{id code nameLocal nameEng}
      faculty{id code nameLocal nameEng}
      department{id code nameLocal nameEng}
      code
      prefix{
        id nameLocal nameEng nameShortLocal nameShortEng
      }
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      gender
      telephone
      email
      birthDate
      citizenId
      project{id nameLocal nameEng}
      studentStatus{id nameLocal nameEng}
      examLocation
      user{id userLogin }
    }
  }
`;

export const ADD_STUDENTS_UPLOAD = gql`
  mutation addStudentsUpload(
    $studentsUploadInput: [StudentsUploadInput]
  ) {
    addStudentsUpload (
      studentsUploadInput: $studentsUploadInput,
    )
    {
      successCount
      failCount
      resultAddStudentUpload{
        no degreeCode curriculumCode facultyCode departmentCode code firstNameLocal lastNameLocal firstNameEng lastNameEng
        gender telephone email citizenId status remark
      }
    }
  }
`;

export const UPDATE_STUDENT = gql`
  mutation updateStudent(
    $id: ID!,
    $studentInput: StudentInput!,
    $curriculumId: ID!,
    $facultyId: ID!,
    $prefixId: ID!,
    $userId: ID,
  ) {
    updateStudent(
      id: $id
      studentInput: $studentInput
      curriculumId: $curriculumId
      facultyId: $facultyId
      prefixId: $prefixId
      userId: $userId
    ) {
      id
      degree{id code nameLocal nameEng}
      curriculum{id code nameLocal nameEng}
      faculty{id code nameLocal nameEng}
      department{id code nameLocal nameEng}
      code
      prefix{
        id nameLocal nameEng nameShortLocal nameShortEng
      }
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      gender
      telephone
      email
      birthDate
      citizenId
      project{id nameLocal nameEng}
      studentStatus{id nameLocal nameEng}
      examLocation
      user{id userLogin }
    }
  }
`;

export const DELETE_STUDENT = gql`
  mutation deleteStudent($id: ID!) {
    deleteStudent(
      id: $id
    ) {
      id
      degree{id code nameLocal nameEng}
      curriculum{id code nameLocal nameEng}
      faculty{id code nameLocal nameEng}
      department{id code nameLocal nameEng}
      code
      prefix{
        id nameLocal nameEng nameShortLocal nameShortEng
      }
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      gender
      telephone
      email
      birthDate
      citizenId
      project{id nameLocal nameEng}
      studentStatus{id nameLocal nameEng}
      examLocation
      user{id userLogin }
    }
  }
`;

